import React from 'react'
import UserUtterance from './UserUtterance'
import AssistantUtterance from './AssistantUtterance'

const Utterance = ({ utterance, onSaveClick, onGoodClick, onBadClick, onFeedbackClick, addMessage=null, agents=[], addGraphs=[], pdfPathList=[], nextQuestions=[], showSpinner, errMsg }) => {
  if (!utterance) {
    return null;
  }

  return (
    <>
      {utterance.is_user ? (
        <UserUtterance
          chatHistoryId={utterance.chat_history_id}
          message={utterance.utterance}
        />
      ) : (
        <AssistantUtterance
          message={utterance.utterance}
          chatHistoryId={utterance.chat_history_id}
          isGood={utterance.good}
          isBad={utterance.bad}
          feedback={utterance.feedback}
          graphs={utterance.chat_graph}
          evidences={pdfPathList.length > 0 ? pdfPathList :utterance.chat_evidence}  
          onGoodClick={onGoodClick}
          onBadClick={onBadClick}
          onSaveClick={onSaveClick}
          onFeedbackClick={onFeedbackClick}
          addMessage={addMessage}
          agents={agents}
          addGraphs={addGraphs}
          nextQuestions={nextQuestions}
          showSpinner={showSpinner}
          errMsg={errMsg}
        />
      )}
    </>
  )
}

export default Utterance